import RoutesMap from '../../route_control/RouteControl'
import { DayList } from '../../pages/day'

export const DayRouteImport = { RoutesMap, DayList }
